function a() {
	document.documentElement.style.setProperty(
		'--viewport-width',
		document.documentElement.clientWidth.toString()
	);
}

window.addEventListener('resize', a);
a();

export {};
